module.exports = __webpack_public_path__ + "static/media/ZILLASLAB-REGULAR_0.e9d0d856.OTF";